export const BLOCKS = [
  {
    key: 'recommendations',
    title: 'Рекомендованные профессии',
    description:
      'Эта подборка профессий соответствует тем приоритетам, которые определил/определила для себя при прохождении тест-игры',
    method: 'getProfessions',
    data: null,
  },
  {
    key: 'competencies',
    title: 'Программы, чтобы узнать',
    description:
      'Эти программы помогут узнать больше о подходящих профессиональных сферах',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'professions',
    title: 'Программы, чтобы попробовать',
    description:
      'Эти программы помогут получить практические навыки в подходящих профессиональных областях',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'orientation',
    title: 'Профориентационные программы',
    description:
      'Это программы общей направленности, которые помогут определиться с выбором профессии',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'articles',
    title: 'Рекомендованные статьи',
    description:
      'Эти интересные статьи, подобранные нашими редакторами, помогут ребенку узнать больше о подходящих ему профессиях',
    method: 'getMaterials',
    data: null,
  },
  {
    key: 'interviews',
    title: 'Рекомендованные интервью',
    description:
      'В этих интервью представители профессий рассказывают нашему сервису о своей работе',
    method: 'getMaterials',
    data: null,
  },
  // {
  //   key: 'videos',
  //   title: 'Рекомендованные видео',
  //   description:
  //     'Рекомендуем посмотреть эти видео, связанные с подходящими профессиям',
  //   method: 'getMaterials',
  //   data: null,
  // },
];



// WEBPACK FOOTER //
// ./src/pages/profile/views/cabinet/components/smart/const.ts